import React, { useState } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';

import useUser from '../../../../hooks/useUser';
import { initialFile, validateFile } from '../helpers/ValidateFile';
import ClaimService from '../../../../services/Claim';
import LoadingModal from '../../../LoadingModal/LoadingModal';
import FormTemplate from '../../FormTemplate';
import ConversionStep from '../Components/ConversionStep/ConversionStep';

import { StepOne, StepTwo, LastStep } from './Steps';

const steps = [
  {
    title: 'Datos',
    subtitle: 'Siguiente paso: Comprobante',
    stepComponent: StepOne,
    fieldNames: ['number', 'mail', 'rechargeAmount'],
  },
  {
    title: 'Comprobante',
    subtitle: 'Siguiente paso: Inconveniente',
    stepComponent: StepTwo,
    fieldNames: ['file'],
  },
  {
    title: 'Inconveniente',
    subtitle: '¡Ya casi terminamos!',
    stepComponent: LastStep,
    fieldNames: ['details'],
  },
];

const validationSchema = yup.object({
  number: yup
    .string()
    .matches(/^[0-9]{9}$/, { message: 'El teléfono ingresado no es válido' })
    .required('Campo obligatorio')
    .length(9),
  mail: yup
    .string()
    .email('El Email ingresado tiene formato inválido')
    .required('Campo obligatorio'),
  rechargeAmount: yup
    .number()
    .min(1000, 'El monto debe ser entre $1.000 y $25.000')
    .max(25000, 'El monto debe ser entre $1.000 y $25.000')
    .required('Campo obligatorio'),
  file: yup
    .object()
    .test('El archivo existe', 'Campo obligatorio', validateFile)
    .required('Campo obligatorio'),
  details: yup
    .string()
    .min(15, 'Debes ingresar al menos 15 caracteres')
    .max(700),
});

const FormRechargePurchase = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [errorCode, setErrorCode] = useState(0);
  const {
    plan: { number: initialNumber },
    user: { mail: initialMail },
  } = useUser();
  const handleSubmit = data => {
    setLoading(true);

    ClaimService.sendFormData({
      affectedSubscriberNumber: data.number,
      contactEmail: data.mail,
      complainType: 'S_ARP_SR_BR_RRAA',
      attentionDetail: data.details,
      attachments: [data.file],
      claimedAmount: data.rechargeAmount,
    })
      .then(([{ message: response }]) => {
        setMessage(response);
        setErrorCode(0);
      })
      .catch(({ status }) => {
        setErrorCode(status ?? 400);
      })
      .finally(() => setLoading(false));
  };
  return (
    <>
      {loading && <LoadingModal />}
      <Formik
        initialValues={{
          number: initialNumber.replace(/^56/, ''),
          mail: initialMail,
          file: initialFile,
          rechargeAmount: '',
          details: '',
        }}
        onSubmit={values => handleSubmit(values)}
        validateOnMount
        validationSchema={validationSchema}
      >
        {message || errorCode ? (
          <ConversionStep
            paragraph={message}
            error={errorCode === 400}
            serviceError={errorCode !== 0 && errorCode !== 400}
            kindOfForm="recargas"
          />
        ) : (
          <FormTemplate formName="Formulario Recargas" steps={steps} />
        )}
      </Formik>
    </>
  );
};

export default FormRechargePurchase;
